import processIdPCallback from 'api/idPCallback'
import React from 'react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const IdPCallback: React.FC = () => {
  const location = useLocation()

  useEffect(() => {
    void processIdPCallback(location)
  }, [location])
  return <></>
}

export default IdPCallback
